/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ./images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('./images', true)
// const imagePath = (name) => images(name, true)

import "./stylesheets/application.scss";
import * as bootstrap from "bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "@fortawesome/fontawesome-free";
import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/brands'
import "@oddcamp/cocoon-vanilla-js";
import Choices from "choices.js";
import Rails from "@rails/ujs";

import { pageTableInit } from "./datatables";
Rails.start();

document.addEventListener('DOMContentLoaded', () => {
  selectChoicesInit()
  toasts()
})

function cocoonAfterInserEnableSelectPicker() {
  const form = document.querySelector('#room_form');
  if (form) {
    form.addEventListener('cocoon:after-insert', (event) => {
      selectChoices('.selectpicker');
    })
  }
}

function selectChoicesInit(className) {
  try {
    selectChoices('.selectpicker');
    pageTableInit()
  } catch (e) {

  }
  try {
    cocoonAfterInserEnableSelectPicker();
  } catch (e) {

  }
}

function toasts() {
  const toastElList = [].slice.call(document.querySelectorAll('.toast'))
  const toastList = toastElList.map(function (toastEl) {
    if (toastEl.querySelector('.toast-body').innerHTML.length !== 0)
      return new bootstrap.Toast(toastEl)
    else
      return null
  })
  toastList.forEach(toast => toast && toast.show())
}

export default function selectChoices(className) {
  document.querySelectorAll(className).forEach(element => {
    const search = element.getAttribute('data-live-search');
    new Choices(element, {
      allowHTML: true,
      duplicateItemsAllowed: true,
      searchEnabled: search === 'true',
      renderSelectedChoices: 'no',
      loadingText: 'Загрузка...',
      noResultsText: 'Не найдено',
      noChoicesText: 'No choices to choose from',
      itemSelectText: 'Выбрать',
      shouldSort: false,
    });
  })
}